import { measurementPreferences, measurementNames } from "./EnumHelpers";

export const GRAMS_TO_OUNCES_FACTOR = 0.03527392;
export const ML_TO_FLOZ_FACTOR = 0.0338140227;

// Converts base-weight foods' ServingAmount from oz/fl oz back to grams/ml before
// sending in a PUT. The backend stores values in grams/ml but the GET API returns
// them converted to the imperial display unit. Only applies to foods without a
// named serving (ServingId is null/0).
export const convertBaseWeightFoodsOzToGrams = (foods) => {
    if (foods == null) return;
    foods.forEach(food => {
        if (typeof food.ServingAmount === "number" && !isNaN(food.ServingAmount) && (food.ServingId == null || food.ServingId === 0)) {
            let factor = 1;
            if (food.DefaultServingType === "oz") {
                factor = GRAMS_TO_OUNCES_FACTOR;
            } else if (food.DefaultServingType === "fl oz") {
                factor = ML_TO_FLOZ_FACTOR;
            }
            if (factor !== 1) {
                food.ServingAmount = round(food.ServingAmount / factor, 2);
            }
        }
    });
};

export const getBmiByMeasurementPreference = (measurementPreference, heightCm, heightFt, heightIn, weightKg, weightSt, weightLb) => {
    var res = convertToMetricByMeasurementPreference(measurementPreference, heightCm, heightFt, heightIn, weightKg, weightSt, weightLb);

    return getBmi(res.weightKg, res.heightM);
}

export const getBmi = (weightKg, heightM) => {
    return (weightKg / (heightM * heightM));
}

export const convertStringToMeasurementPreferences = (source) => {
    switch (source.toLowerCase()) {
        case "metric":
            return measurementPreferences.Metric;
        case "imperial":
            return measurementPreferences.Imperial;
        case "usstandard":
        case "us":
            return measurementPreferences.UsStandard;
        default:
            return measurementPreferences.Metric;
    }
    return
};

export const convertToMetricByMeasurementPreference = (measurementPreference, heightCm, heightFt, heightIn, weightKg, weightSt, weightLb) => {
    var res = {
        weightKg: 0,
        heightM: 0
    };
    switch (measurementPreference) {
        case measurementPreferences.Metric:
            res.weightKg = weightKg;
            res.heightM = heightCm / 100
            break;
        case measurementPreferences.Imperial:
            res.weightKg = convertStLbToKg(weightSt, weightLb);
            res.heightM = convertFtInToCm(heightFt, heightIn) / 100;
            break;
        case measurementPreferences.UsStandard:
            res.weightKg = convertLbToKg(weightLb);
            res.heightM = convertFtInToCm(heightFt, heightIn) / 100;
            break;
    }
    return res;
}

export const convertMeasurmentsByMeasurementPreference = (measurementPreference, heightCm, weightKg) => {
    var res = {
        heightCm: null,
        heightFt: null,
        heightIn: null,
        weightKg: null,
        weightSt: null,
        weightLb: null
    };
    switch (measurementPreference) {
        case measurementPreferences.Metric:
            res.weightKg = weightKg;
            res.heightCm = heightCm
            break;
        case measurementPreferences.Imperial:
            var stLb = convertKgToStLb(weightKg);
            res.weightSt = stLb.stones;
            res.weightLb = stLb.pounds;

            var ftIn = convertCmToFtIn(heightCm);
            res.heightFt = ftIn.feet;
            res.heightIn = ftIn.inches;
            break;
        case measurementPreferences.UsStandard:
            var stLb = convertKgToStLb(weightKg);
            res.weightLb = convertStToLb(stLb.stones) + stLb.pounds;

            var ftIn = convertCmToFtIn(heightCm);
            res.heightFt = ftIn.feet;
            res.heightIn = ftIn.inches;
            break;
        default:
            break;
    }
    return res;
}

export const convertFtInToCm = (feet, inches) => {
    return convertInToCm((feet * 12) + (1 * inches));
}

export const convertInToCm = (inches) => {
    return (inches * 2.54);
}

export const convertStLbToKg = (st, lb) => {
    return convertLbToKg((st * 14) + (1 * lb)).toFixed(1);
}

export const convertLbToKg = (lb) => {
    //return (lb / 2.2046).toFixed(1);
    return (lb / 2.2046);
}

export const convertKgToStLb = (kg) => {
    var lb = convertKgToLb(kg).toFixed(1);
    return {
        //stones: lb > 0 ? Math.floor(lb / 14) : Math.floor(Math.abs(lb) / 14) * -1,
        stones: Math.floor(lb / 14),
        pounds: lb % 14
    };
}

export const convertKgToLb = (kg) => {
    return (kg * 2.2046);
}

export const convertBmiToKg = (bmi, height_m) => {
    return bmi * height_m * height_m;
}

export const convertStToLb = (st) => {
    return st * 14;
}

export const convertLbToStLb = (lb) => {
    return {
        stones: lb > 0 ? Math.floor(lb / 14) : Math.floor(Math.abs(lb) / 14) * -1,
        pounds: lb % 14
    };
}

export const convertCmToFtIn = (cm) => {
    var inches = convertCmToIn(cm);
    return {
        feet: Math.floor(inches / 12),
        inches: inches % 12
    }
}

export const convertCmToIn = (cm) => {
    return cm / 2.54;
}

export const convertKgByMeasurementPreference = (measurementPref, kg, decimalPlaces) => {
    switch (measurementPref) {
        case measurementPreferences.Metric:
            return '' + round(kg, decimalPlaces) + 'kg';
        case measurementPreferences.Imperial:
            const res1 = convertKgToStLb(kg);
            return '' + round(res1.stones, decimalPlaces) + 'st ' + round(res1.pounds, decimalPlaces) + 'lb';
        case measurementPreferences.UsStandard:
            const res2 = convertKgToStLb(kg);
            var lbs = 0 + convertStToLb(res2.stones) + res2.pounds;
            return '' + lbs + 'lb';
        default:
    }
}

export const getUnitLabels = (measurementPreference) => {
    var unitLabels = {
        weight: '',
        height: ''
    };
    switch (measurementPreference) {
        case measurementPreferences.Imperial:
            unitLabels = {
                weight: '(Stones and Pounds)',
                height: '(Feet and Inches)'
            }
            break;
        case measurementPreferences.Metric:
            unitLabels = {
                weight: '(Kg)',
                height: '(Cm)'
            }
            break;
        case measurementPreferences.UsStandard:
            unitLabels = {
                weight: 'Pounds',
                height: 'Height'
            }
            break;
    }
    return unitLabels;
}

export const round = (val, decimalPlaces) => {
    var shifter = Math.pow(10, decimalPlaces);
    return Math.round(val * shifter) / shifter;
}

export const roundMeasurement = (name, value) => {
    var ret = roundMeasurementRaw(name, value);
    return ret === 0 ? null : ret;
};

export const roundMeasurementRaw = (name, value) => {
    var ret = value;
    switch (name) {
        case measurementNames.weightSt:
        case measurementNames.heightFt:
        case measurementNames.goalWeightSt:
            return round(value, 0);

        case measurementNames.weightKg:
        case measurementNames.goalWeightKg:
        case measurementNames.heightCm:
        case measurementNames.armsCm:
        case measurementNames.chestCm:
        case measurementNames.hipsCm:
        case measurementNames.waistCm:
        case measurementNames.thighsCm:
            return round(value, 1);

        case measurementNames.weightLb:
        case measurementNames.heightIn:
        case measurementNames.goalWeightLb:
            return round(value, 1);
        default:
            return value;
    }
};

export const convertBetweenMeasurementPreferences = ({ oldMeasurementPreference, newMeasurementPreference, heightCm, heightFt, heightIn, weightKg, weightSt, weightLb }) => {
    //convert values to metric first.
    var metricValues = convertToMetricByMeasurementPreference(oldMeasurementPreference, heightCm, heightFt, heightIn, weightKg, weightSt, weightLb);

    //convert metric to required new measurementPreference.
    var res = convertMeasurmentsByMeasurementPreference(newMeasurementPreference, metricValues.heightM * 100, metricValues.weightKg);

    return {
        measurementPreference: newMeasurementPreference,
        heightCm: res.heightCm,
        heightFt: res.heightFt,
        heightIn: res.heightIn,
        weightKg: res.weightKg,
        weightSt: res.weightSt,
        weightLb: res.weightLb
    };
};

export const gramsToCalories = (nutrient, type) => {
    // This formula was provided by Laura. It should be the same used in ClickFit.
    // To convert protein from grams to calories, multiply by 4
    // To convert carbohytrates from grams to calories, multiply by 4
    // To convert fat from grams to calories, multiply by 9
    if (type.toLowerCase() === "fat") {
        return nutrient * 9;
    }
    else if (type.toLowerCase() === "protein" || type.toLowerCase() === "carbs") {
        return nutrient * 4;
    }
    return nutrient;
};